import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceCurlyArrowLeft = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-curly-arrow-left")} iconColor={color} size={size} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.5567 23.04C14.7589 20.1957 13.2827 15.7261 5.75994 15.7261L25.6 15.7261M14.5567 8.32001C14.759 11.1643 13.2827 15.6339 5.75994 15.6339" stroke="white" strokeWidth="1.05143"/>
  </IconWrapper>
)
